import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import { useParams } from "react-router-dom";
import LoadingScreen from "../../organisms/LoadingScreen";
import { useQuery } from "@tanstack/react-query";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { Card,  Row } from "react-bootstrap";
import styled from "styled-components";
import CardTitle from "../../organisms/CardTitle";
import { obtenerCancelacionPreliminarHotel, QUERY_OBTENER_CANCELACION_PRELIMINAR_HOTEL } from "../../../services/cancelacionesServicios";
import { buscarPorId, QUERY_BUSCAR_AGENDAMIENTO_HOTEL_POR_ID } from "../../../services/agendamientosHotelServicios";
import CancelacionPreliminar from "./CancelacionPreliminar";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/reservas",
    label: "Reservas por Tipo",
  },
  {
    path: "/reservas/hotel",
    label: "Reserva Hotel",
  },
  {
    path: "/reservas/hotel/cancelar",
    label: "Cancelar",
    isActive: true,
  }
];

function CancelarAgendamientoHotel() {
  let { idAgendamiento } = useParams();

  const {
    data: cancelacionPreliminar,
    isLoading: cancelacionPreliminarIsLoading,
    isError: cancelacionPreliminarIsError,
  } = useQuery({
    queryKey: [QUERY_OBTENER_CANCELACION_PRELIMINAR_HOTEL],
    enabled: idAgendamiento !== undefined,
    queryFn: async () =>
      await obtenerCancelacionPreliminarHotel(idAgendamiento || '')
  });

  const {
    data: agendamiento,
    isLoading: agendamientoIsLoading,
    isError: agendamientoIsError,
  } = useQuery({
    queryKey: [QUERY_BUSCAR_AGENDAMIENTO_HOTEL_POR_ID],
    enabled: idAgendamiento !== undefined,
    queryFn: async () =>
      await buscarPorId(idAgendamiento || '')
  });

  const isLoading = cancelacionPreliminarIsLoading || agendamientoIsLoading;
  const isError = cancelacionPreliminarIsError || agendamientoIsError;

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isError) {
    return <ServerErrorModal />;
  }

  return (
    <>
      <Page
        title="Cancelar Agendamiento de Hotel"
        description="Revisión y cancelación de agendamiento."
        breadCrumbs={breadCrumbs}
      >
        {(cancelacionPreliminar && agendamiento) && (
          <Row className="justify-content-center">
            <div className="col-xs-12 col-md-12 col-lg-8 col-xxl-6">
              <StyledCard>
                <StyledCardHeader className="mt-3 mb-3">
                  <CardTitle>{"Detalles de Cancelación"}</CardTitle>
                </StyledCardHeader>
                <StyledCardBody>
                  <CancelacionPreliminar agendamiento={agendamiento} cancelacionPreliminar={cancelacionPreliminar} />
                </StyledCardBody>
              </StyledCard>
            </div>
          </Row>
        )}
      </Page>
    </>
  );
}

const StyledCard = styled(Card)`
  margin-bottom: 1.875rem;
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardBody = styled(Card.Body)`
  padding: 1.25rem;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0px;
`;

export default CancelarAgendamientoHotel;
